import LogoBbc from '@/images/logos/bbc.svg'
import LogoCbs from '@/images/logos/cbs.svg'
import LogoCnn from '@/images/logos/cnn.svg'
import LogoFastCompany from '@/images/logos/fast-company.svg'
import LogoForbes from '@/images/logos/forbes.svg'
import LogoHuffpost from '@/images/logos/huffpost.svg'
import LogoTechcrunch from '@/images/logos/techcrunch.svg'
import LogoWired from '@/images/logos/wired.svg'
import QrCode from '@/images/qr-code.svg'
import ForProgrammers from "@/images/for_programmers.svg"
import ForEngineers from "@/images/for_engineers.svg"
import ForArchitects from "@/images/for_architects.svg"
import Logo from "@/images/logo.svg"
import React, { type FC, type SVGProps } from "react";
import {
  CheckIcon,
  ChevronUpIcon,
  DeviceArrowIcon,
  DeviceCardsIcon,
  DeviceChartIcon,
  DeviceClockIcon,
  DeviceListIcon,
  DeviceLockIcon,
  DeviceNotificationIcon,
  DeviceTouchIcon,
  DeviceUserIcon,
  LogoIcon,
  LogomarkIcon,
  LogoWithLogomark,
  MenuIcon,
  PlayIcon,
  QrCodeBorderIcon,
  StarIcon,
  UserIcon,
  EmailGradient
} from "@/images/icons/icons";
import Image, { type StaticImageData } from "next/image";


/*
* Whenever adding a new SVG/icon to files or icons.tsx,
* please also import it here and add to the list below with an alias.
*/
const svgs = {
  "LogoBbc": LogoBbc as FC<SVGProps<SVGElement>>,
  "LogoCbs": LogoCbs as FC<SVGProps<SVGElement>>,
  "LogoCnn": LogoCnn as FC<SVGProps<SVGElement>>,
  "LogoFastCompany": LogoFastCompany as FC<SVGProps<SVGElement>>,
  "LogoForbes": LogoForbes as FC<SVGProps<SVGElement>>,
  "LogoHuffpost": LogoHuffpost as FC<SVGProps<SVGElement>>,
  "LogoTechcrunch": LogoTechcrunch as FC<SVGProps<SVGElement>>,
  "LogoWired": LogoWired as FC<SVGProps<SVGElement>>,
  "DeviceArrowIcon": DeviceArrowIcon,
  "DeviceCardsIcon": DeviceCardsIcon,
  "DeviceClockIcon": DeviceClockIcon,
  "DeviceListIcon": DeviceListIcon,
  "DeviceLockIcon": DeviceLockIcon,
  "DeviceChartIcon": DeviceChartIcon,
  "DeviceUserIcon": DeviceUserIcon,
  "DeviceNotificationIcon": DeviceNotificationIcon,
  "DeviceTouchIcon": DeviceTouchIcon,
  "LogoIcon": LogoIcon,
  "MenuIcon": MenuIcon,
  "UserIcon": UserIcon,
  "StarIcon": StarIcon,
  "CheckIcon": CheckIcon,
  "PlayIcon": PlayIcon,
  "ChevronUpIcon": ChevronUpIcon,
  "EmailGradient": EmailGradient,
  "QrCode": QrCode as FC<SVGProps<SVGElement>>,
  "QrCodeBorderIcon": QrCodeBorderIcon,
  "LogomarkIcon": LogomarkIcon,
  "LogoWithLogomark": LogoWithLogomark,
  "ForProgrammers": ForProgrammers as FC<SVGProps<SVGElement>>,
  "ForEngineers": ForEngineers as FC<SVGProps<SVGElement>>,
  "ForArchitects": ForArchitects as FC<SVGProps<SVGElement>>,
  "Logo": Logo as FC<SVGProps<SVGElement>>
}

function isNextImage(obj: unknown): obj is StaticImageData {
  return !!obj && typeof obj === 'object' && 'src' in obj && 'height' in obj && 'width' in obj;
}

type FileNames = keyof typeof svgs;

interface ImageRendererProps {
  name: string;
  index?: number | string;

  [key: string]: unknown;
}

// Renders images(svgs, icons..) from a string alias.
export default function ImageRenderer({ name, index, ...props }: ImageRendererProps) {
  const component = svgs[name as FileNames];

  if (isNextImage(component)) return React.createElement(Image, {
    key: index,
    src: component,
    alt: name,
    ...props
  })

  const SVG = component as FC<SVGProps<SVGElement>>;

  if (typeof component !== 'undefined') {
    return React.createElement(SVG as FC<typeof props>, {
      key: index,
      ...props
    })
  }
  return React.createElement(
    () => <div>The image {name} has not been created yet.</div>,
    { index: index }
  )
}
